import React from "react";
import { useDashboardCarouselSwipe } from "../../hooks/useDashboardCarouselSwipe";
import { AccountsReceivableHubScreen } from "./AccountsReceivableHubScreen";

const SCREEN_STYLE = {
  minHeight: "100vh",
  // ModuleShell canvas owns width/gutters; keep this host as a full-bleed
  // carousel backdrop so padding is not nested inside `.cp-desktop-page`.
  padding: 0,
  color: "white",
  background:
    "radial-gradient(circle at 20% 10%, rgba(201,168,76,0.12), transparent 60%), linear-gradient(180deg, rgba(7,10,16,1) 0%, rgba(4,7,12,1) 100%)",
};

export default function AccountsReceivableScreen({
  currentUser,
  onBack,
  onOpenInvoice,
  onCarouselNavigate,
  onOpenNavigator,
}) {
  const { ref: carouselRef, style: carouselTouchStyle } =
    useDashboardCarouselSwipe({
      onNavigate: onCarouselNavigate,
      onOpenNavigator,
    });

  return (
    <div ref={carouselRef} style={{ ...SCREEN_STYLE, ...carouselTouchStyle }}>
      <AccountsReceivableHubScreen
        currentUser={currentUser}
        onBack={onBack}
        onOpenInvoice={onOpenInvoice}
      />
    </div>
  );
}
